import React from 'react';
import { useParams } from 'react-router-dom';

import BackButton from '@ts-core/components/BackButton';
import AssignmentAnswer from '@ts-core/modules/assignments/components/AssignmentAnswer';

import { useStudentAnsweredAssignment } from 'modules/assignments/hooks';
import { useStudent } from 'modules/students/hooks';

const StudentCourseAssignmentResultsPage = () => {
  const { courseId, assignmentId, studentId } = useParams<{ courseId: string; studentId: string; assignmentId: string }>();
  const { assignment, loading } = useStudentAnsweredAssignment({
    courseId,
    assignmentId,
    studentId,
  });
  const { student } = useStudent({ courseId, studentId });

  return (
    <>
      <BackButton title={assignment?.name} subtitle={student?.name} href={`/${courseId}/students/${studentId}/assignments`} />
      <AssignmentAnswer assignment={assignment} loading={loading} />
    </>
  );
};

export default StudentCourseAssignmentResultsPage;
